import { Injectable } from '@angular/core';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { IConfigurableTable } from "libraries/interfaces/i-configurable-table";
import { Observable } from "rxjs";
import { CONFIG_DEFAULT } from "app_sasha/pages/process-report/components/process-report-table/config-default";

@Injectable()
export class ProcessReportTableDomainService {

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService
    ) {
    }

    public getConfig(): Observable<IConfigurableTable> {
        return this.configurationResourceService.get(
            ['wui', 'app_sasha', 'config', 'process-report', 'process-report-table.json'],
            CONFIG_DEFAULT
            );
    }
}
